import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const GetMyTaxRates = graphql(`
  query GetMyTaxRates {
    me {
      user {
        account {
          taxRates {
            id
            publicId
            label
            percentage
            isDefault
            isReverseCharge
            isIncluded
          }
        }
      }
    }
  }
`);

const useGetMyTaxRates = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.accountTaxRates(),
    queryFn: () => {
      return gqlClient.request(GetMyTaxRates);
    },
  });

  return {
    taxRates: data?.me.user.account.taxRates,
    defaultTaxRate: data?.me.user.account.taxRates.find(
      (taxRate) => taxRate.isDefault
    ),
    ...rest,
  };
};

export default useGetMyTaxRates;
